// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"205d09d7","60":"36e7bb7f","63":"9eee5158","143":"65851a61","202":"80640d8e","407":"832d23c1","437":"f8d2cb31","453":"99a55f81","511":"89684696","715":"c63de921","917":"71ac392f","954":"f695e2f8"}[chunkId] + ".chunk.js";
};